import React from 'react';
import {connect} from 'react-redux';
import {trackingDomainActions} from '../../../store/actions/trackingDomainAction';
import TrackingDomainsList from './TrackingDomainsList';
import AddTrackingDomain from './AddTrackingDomain';
import DomainManager from './DomainManager';

export const TrackingDomains = props => <DomainManager {...props} kind="tracking"
    description="Choose the domain used in your campaign tracking links." data={props.state.trackingDomains}
    Form={AddTrackingDomain} List={TrackingDomainsList} load={props.loadTrackingDomains} resetDomain={props.setTrackingDomain}/>;

export default connect(state => ({state: state.trackingDomain}), {
    loadTrackingDomains: trackingDomainActions.fetch,
    addAndVerify: trackingDomainActions.addAndVerify,
    clearErrors: trackingDomainActions.clearErrors,
    setActiveStep: trackingDomainActions.setStep,
    setTrackingDomain: trackingDomainActions.setTrackingDomain
})(TrackingDomains);
